import { Typography } from "@mui/material";
import React from "react";
import FormNumber from "./FormNumber";

const AddNumber = ({ handleToggle }) => {
  return (
    <>
      <Typography variant="Poster" component="h4" gutterBottom>
        Add a new number to this WhatsApp account
      </Typography>
      <FormNumber handleSuccess={handleToggle} />
    </>
  );
};

export default AddNumber;
